import { render, staticRenderFns } from "./MobileProjects.vue?vue&type=template&id=2e553291&scoped=true&"
import script from "./MobileProjects.vue?vue&type=script&lang=ts&"
export * from "./MobileProjects.vue?vue&type=script&lang=ts&"
import style0 from "./MobileProjects.vue?vue&type=style&index=0&id=2e553291&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e553291",
  null
  
)

export default component.exports